<template>
  <div id="UserSetting">
    <eb-header>
      <eb-break-crumb slot="breakCrumb" />
    </eb-header>
    <UserSettingDetail :user="user" />
    <ModifyUserPass />
    <ModifyUserPhone />
    <UploadHeadImg />
    <WxBind operType="REBIND" />
    <UploadWxQRCode :openidPublic="user.openidPublic" :nickname="user.nickname" />
  </div>
</template>
<script>
import ebHeader from '@/components/common/eb-header';
import ebBreakCrumb from '@/components/common/eb-break-crumb';
import UserSettingDetail from '@/components/user/UserSettingDetail';
import ModifyUserPass from '@/components/user/personset/ModifyUserPass';
import ModifyUserPhone from '@/components/user/personset/ModifyUserPhone';
import UploadHeadImg from '@/components/user/personset/UploadHeadImg';
import UploadWxQRCode from '@/components/user/personset/UploadWxQRCode';
import WxBind from '@/components/user/personset/WxBind';
import { getUserById } from '@/services/user/user-service';
import eventBus from '@/plugins/event-bus';
export default {
  name: 'UserSetting',
  components: {
    ebHeader,
    ebBreakCrumb,
    UserSettingDetail,
    ModifyUserPass,
    ModifyUserPhone,
    UploadHeadImg,
    UploadWxQRCode,
    WxBind
  },
  data() {
    return {
      loading: true,
      user: {},
      departId: this.$store.state.user.userInfo.departId,
      userId: this.$store.state.user.userInfo.userid
    };
  },
  created() {
    this.initUser();
    eventBus.$on('loadUserInfo', type => {
      this.loadUserInfo(type);
    });
  },
  methods: {
    async initUser() {
      this.$root.layout.isLoading = true;
      try {
        let { data } = await getUserById(this.userId);
        if (data.user != null) {
          this.user = data.user;
        } else {
          this.$message.error('获取账户信息失败');
        }
      } catch (error) {
        this.$message.error(error.message);
      }
      this.$root.layout.isLoading = false;
    },
    async loadUserInfo(type) {
      try {
        let { data } = await getUserById(this.user.userId);
        if (data.returnCode === '01') {
          if (type === 'wxQrcode') {
            this.user.wxQRCodeImg = data.user.wxQRCodeImg;
          } else if (type === 'headImg') {
            this.user.headImg = data.user.headImg;
          }
        } else {
          this.$message.error('获取账户信息失败');
        }
      } catch (error) {
        this.$message.error(error.message);
      }
    }
  },
  beforeDestroy() {
    eventBus.$off('loadUserInfo');
  }
};
</script>
<style scoped lang="less">
.panel-box {
  width: 94%;
  margin: 0 auto;
  padding-top: 30px;
  padding-bottom: 30px;
}
</style>
